import { createSlice } from '@reduxjs/toolkit';

import { defaultLegendMode } from './source-legend.constants';

const sourceLegend = createSlice({
  name: 'sourceLegend',
  initialState: {
    selectedMode: defaultLegendMode,
  },
  reducers: {
    setSelectedMode: (state, action) => {
      state.selectedMode = action.payload;
    },
  },
});

export const { setSelectedMode } = sourceLegend.actions;
export default sourceLegend.reducer;
